export default __webpack_public_path__ + "static/media/ic_hospitals.95d5841a.svg";